<fv-contextmenu class="relative z-[201]" #cameraSelectorContextMenu></fv-contextmenu>

<div class="h-screen w-screen fixed left-0 bg-zinc-900 transition-all duration-300" style="z-index:200;" [ngStyle]="{
  'top': isScannerModalWrapperOpen ? '0%' : '100%'
}">

  <div class="h-full relative">

    <div class="w-full absolute top-0 left-0 z-20">
      <div class="p-4 bg-gradient-to-b from-zinc-950 to-zinc-950/80" style="backdrop-filter: blur(16px);">
        <div class="clear" [style]="{ 'height': insetTop }"></div>
        <div class="flex items-center h-full">
          <div class="flex-grow-0">
            <fv-button (click)="onClickClose()" [color]="BUTTON_COLOR.transparent" [disabled]="!isCloseEnabled"
              [variant]="BUTTON_VARIANT.icononly" icon="far fa-chevron-down">
            </fv-button>
          </div>
          <div class="flex-grow text-sm dark:text-white text-center">
            <div class="opacity-80 text-blue-200" *ngIf="scannerStatus === FV_SCANNER_STATUS.loading">
              Loading...
            </div>
            <div class="opacity-80 text-green-200" *ngIf="scannerStatus === FV_SCANNER_STATUS.scanning">
              Scanning
            </div>
            <div class="opacity-80 text-yellow-200" *ngIf="scannerStatus === FV_SCANNER_STATUS.paused">
              Paused
            </div>
            <div class="opacity-80 text-red-200" *ngIf="scannerStatus === FV_SCANNER_STATUS.stopped">
              Stopped
            </div>
          </div>
          <div class="flex-grow-0">
            <fv-button (click)="onClickFlash()" [color]="BUTTON_COLOR.transparent"
              [disabled]="!devices.length || !isCloseEnabled || !isFlashAvailable" [variant]="BUTTON_VARIANT.icononly"
              [icon]="flashIcon">
            </fv-button>
            <fv-button *ngIf="showCameraSelector" (click)="onClickCameraSelection($event)"
              [color]="BUTTON_COLOR.transparent" [disabled]="!devices.length || !isCloseEnabled"
              [variant]="BUTTON_VARIANT.icononly" icon="far fa-camera-rotate">
            </fv-button>
          </div>
        </div>
      </div>
    </div>

    <div class="overflow-hidden w-full relative h-full">
      <fv-spinner class="opacity-50" *ngIf="!isScannerStarted"></fv-spinner>

      <ng-container *ngIf="showScanner">
        <zxing-scanner #scanner [poster]="''" [autostart]="false" [formats]="allowedFormats"
          (torchCompatible)="onFlashCompatible($event)" (scanSuccess)="onScanSuccess($event)"
          (scanError)="onScanError($event)" class="relative z-10 no-scrollbar"></zxing-scanner>
      </ng-container>

      <div class="absolute z-20 w-full h-full top-0 left-0 bg-zinc-500 dark:bg-zinc-700
        transition-opacity duration-300" [ngClass]="isSuccessFadeOutActive ? 'opacity-0' : 'opacity-1'"
        *ngIf="isSuccessAlertVisible">
      </div>
    </div>

    <div class="w-full mt-6" [ngClass]="{ 'hidden' : !hasExtraContent }" #scannerExtraContent>
      <ng-content></ng-content>
    </div>
  </div>

</div>